import SheriffHome from "../components/home/SheriffHome";
import MarshallConfig from "../components/marshall-config/MarshallConfig";
import MarshallConfigRede from "../components/marshall-config/MarshallConfigRede";
import Login from "../components/login/Login";

export default [{
    path: "/",
    component: SheriffHome
  },
  {
    path: "/marshall",
    component: MarshallConfig
  },
  {
    path: "/marshall/rede",
    component: MarshallConfigRede
  },
  {
    path: "/login",
    component: Login
  }
];